import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "masking"
    }}>{`Masking`}</h1>
    <p>{`By default all text, inputs, and images are masked. `}</p>
    <p>{`Password inputs are always masked no matter your config.`}</p>
    <p>{`You can configure masking levels when you initialise PostHog`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`export const posthog = new PostHog(
  '<ph_project_api_key>',
  {
    enableSessionReplay: true,
    sessionReplayConfig: {
      // Whether text and text input fields are masked. Default is true.
      // Password inputs are always masked regardless
      maskAllTextInputs: false,
      // Whether images are masked. Default is true.
      maskAllImages: true,
      // Enable masking of all sandboxed system views like UIImagePickerController, PHPickerViewController and CNContactPickerViewController. Default is true.
      // iOS only
      maskAllSandboxedViews: true,
      // rest of your config
  }
}
`}</code></pre>
    <h1 {...{
      "id": "manual-masking"
    }}>{`Manual Masking`}</h1>
    <p>{`To replace any type of `}<inlineCode parentName="p">{`React.Component`}</inlineCode>{` with a redacted version in the replay, set the `}<a parentName="p" {...{
        "href": "https://reactnative.dev/docs/accessibility#accessibilitylabel"
      }}>{`accessibilityLabel`}</a>{` to `}<inlineCode parentName="p">{`ph-no-capture`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`<Text accessibilityLabel="ph-no-capture">Sensitive!</Text>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      